import React from 'react'
import {withStyles, AppBar, Typography, Hidden} from '@material-ui/core'
import {withRouter} from 'react-router-dom'
import {FuseNavigation, FuseLayouts} from '@fuse'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import {get} from 'lodash'

const styles = theme => ({
  root: {
    '& .user': {
      '& .username, & .email & .project': {
        transition: theme.transitions.create('opacity', {
          duration: theme.transitions.duration.shortest,
          easing: theme.transitions.easing.easeInOut,
        }),
      },
    },
  },
  avatar: {
    width: 72,
    height: 72,
    position: 'absolute',
    top: 92,
    padding: 8,
    background: theme.palette.background.default,
    boxSizing: 'content-box',
    left: '50%',
    transform: 'translateX(-50%)',
    '& > img': {
      borderRadius: '50%',
    },
  },
})

function MainNavbar({classes, navigation, layoutStyle, user}) {
  function UserHeader() {
    const projectName = get(user, 'selectedProject.projectName', '')
    return (
      <AppBar
        position="static"
        style={{background: '#2C3033', paddingLeft: 24}}
        elevation={0}
        className="user"
      >
        <Typography className="project text-16" color="inherit">
          {projectName}
        </Typography>
      </AppBar>
    )
  }

  const navigationLayout = FuseLayouts[layoutStyle].type
  return (
    <div className={classes.root}>
      {navigationLayout === 'vertical' ? (
        <React.Fragment>
          <UserHeader />
          <FuseNavigation navigation={navigation} layout={navigationLayout} />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Hidden lgUp>
            <UserHeader />
          </Hidden>
          <FuseNavigation navigation={navigation} layout={navigationLayout} />
        </React.Fragment>
      )}
    </div>
  )
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch)
}

function mapStateToProps({fuse, auth}) {
  return {
    navigation: fuse.navigation,
    layoutStyle: fuse.settings.current.layout.style,
    user: auth.user,
  }
}

export default withStyles(styles, {withTheme: true})(
  withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps,
    )(MainNavbar),
  ),
)



// WEBPACK FOOTER //
// ./src/main/MainNavbarContent.js